import { Injectable } from '@angular/core';
import { AbstractRestService, GenericLambdaReturn } from '@gea-mes/cognito';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EamService extends AbstractRestService {

  postInit(): void {}

  getEAMAssetList(site: string, parent?: string): Observable<GenericLambdaReturn<any>>{
    let params:any={};

    params.Site = site;
    parent != null ? params.Parent = parent:null;

    return this.get({
      //ApiStage: "TPM",
      ApiResource: "/eam/asset",
      data: params,
      repeatCall: false
    })
  }

  createWorkRequest(recordID: number, eamAsset: string, description: string, priority: string, site: string): Observable<GenericLambdaReturn<any>> {
    let params: any = {};

    params.RecordID = recordID;
    params.AssetNumber = eamAsset;
    params.Description = description;
    params.Priority = priority;
    params.Site = site;

    console.log("HERE ARE PARAMS", params);

    return this.post({
      ApiResource: "/eam/workrequest",
      data: params,
      repeatCall: false
    });
  }

  getEAMWorkorders(eamAsset: string){
    let params:any={};

    params.AssetName = eamAsset;
  
    return this.get({
      ApiResource: "/eam/workrequest",
      data: params,
      repeatCall: false
    })

  }
}
